import * as actionTypes from './_actionTypes';
import axiosInstance from '../../services/axios/axios';
import { addMessage, clearMessages } from '../ancillary/actions';
import { deepCloneObject, WrapImsPacket } from '../utility'

//our action creators
export const addNewContainer = container => {
	return {
		type: actionTypes.ADD_NEW_CONTAINER,
		container: container,
	};
};

export const removeContainer = container => {
	return {
		type: actionTypes.REMOVE_CONTAINER,
		container: container,
	};
};

export const checkValidity = validity => {
	return {
		type: actionTypes.CHECK_VALIDITY,
		validationResult: validity,
	};
};

export const checkAllValidity = payload => {
	return {
		type: actionTypes.CHECK_ALL_VALIDITY,
		payload: payload,
	};
};

export const runRulesSync = action => {
	return {
		type: actionTypes.RUN_RULES,
		action: action,
	};
};

export const runRules = action => {
	const payload = {
		rules: action.rules,
		targetMembers: action.allMembers,
		watchMembers: action.watchAllMembers,
		trackingNumber: action.trackingNumber,
	};

	const imsPacket = WrapImsPacket(payload);

	return dispatch => {
		axiosInstance
			.post('/api/Applications/ApplicationRules/id', imsPacket)
			.then(response => {
				dispatch(
					runRulesSync({
						data: response.data.payload,
					}),
				);
			})
			.catch(error => {});
	};
};

export const updateValidity = update => {
	if (
		(update.data.MemberNames && update.data.MemberNames.length === 0) ||
		!update.data.MemberNames
	) {
		return addMessage({ Key: 2, Value: update.data.ErrorMessage });
	} else {
		return {
			type: actionTypes.UPDATE_VALIDITY,
			validationUpdate: update,
		};
	}
};

export const updateValue = value => {
	return {
		type: actionTypes.UPDATE_VALUE,
		valueUpdate: value,
	};
};

export const updateContainerValue = containerInfo => {
	return {
		type: actionTypes.UPDATE_CONTAINER_VALUE,
		containerInfo: containerInfo,
	};
};

export const updateLoading = payload => {
	return {
		type: actionTypes.UPDATE_LOADING,
		updatedValue: payload.updatedValue,
	};
};

export const updateIndex = index => {
	return {
		type: actionTypes.UPDATE_INDEX,
		index: index,
	};
};

export const updateApps = apps => {
	return {
		type: actionTypes.UPDATE_APPS,
		appsData: apps,
	};
};

export const updateSubmitting = payload => {
	return {
		type: actionTypes.UPDATE_SUBMITTING,
		updatedValue: payload.updatedValue,
	};
};

export const updateNewSponsorESOID = ESOID => {
	return {
		type: actionTypes.UPDATE_NEW_SPONSOR_ESOID,
		payload: ESOID,
	};
};

export const updateTabs = data => {
	return {
		type: actionTypes.UPDATE_TABS,
		data: data,
	};
};

export const addApp = app => {
	return {
		type: actionTypes.ADD_APP,
		app: app,
	};
};

export const appSubmitted = submission => {
	return {
		type: actionTypes.APP_SUBMITTED,
		submissionDetails: submission,
	};
};

export const setAppFormValidity = details => {
	return {
		type: actionTypes.SET_APPFORMVALIDITY,
		setDetails: details,
	};
};

export const updateTrackingNumber = info => {
	return {
		type: actionTypes.UPDATE_TRACKINGNUMBER,
		info: info,
	};
};

export const setAppDependencies = map => {
	return {
		type: actionTypes.SET_APP_DEPENDENCIES,
		map: map,
	};
};

export const removeAppSync = index => {
	return {
		type: actionTypes.REMOVE_APP,
		index: index,
	};
};

export const removeApp = appInfo => {
	const trackingNumber = appInfo.trackingNumber;
	const appId = appInfo.appId;

	return dispatch => {
		axiosInstance
			.delete(`/api/Applications/Requests/${trackingNumber}/${appId}`)
			.then(response => {
				switch (response.status) {
					case 200:
						if (response.data.responseCode) {
							const responseCode = response.data.responseCode;
							const messages = response.data.messages;
							switch (responseCode) {
								case 200:
									dispatch(
										removeAppSync({
											index: appInfo.index,
										}),
									);
									clearMessages();
									messages.forEach(message => {
										addMessage(message);
									});
									break;
								default:
									clearMessages();
									messages.forEach(message => {
										addMessage(message);
									});
									break;
							}
						} else {
							clearMessages();
							dispatch(removeAppSync({ index: -1 }));
							dispatch(
								addMessage({
									Key: 3,
									Value: 'Server Error:  Application not removed from cart.',
								}),
							);
						}
						break;
					default:
						clearMessages();
						dispatch(removeAppSync({ index: -1 }));
						dispatch(
							addMessage({
								Key: 3,
								Value: 'Server Error:  Application not removed from cart.',
							}),
						);
						break;
				}
			})
			.catch(error => {
				clearMessages();
				dispatch(removeAppSync({ index: -1 }));
				dispatch(
					addMessage({
						Key: 3,
						Value: 'Server Error:  Application not removed from cart.',
					}),
				);
			});
	};
};

export const callApiPopulateSync = routeInfo => {
	return {
		type: actionTypes.CALL_API_POPULATE,
		apiRouteInfo: routeInfo,
	};
};

export const callApiPopulateStart = () => {
	return {
		type: actionTypes.CALL_API_POPULATE_START,
	};
};
export const callApiPopulateFail = () => {
	return {
		type: actionTypes.CALL_API_POPULATE_FAIL,
	};
};
export const callApiPopulateSuccess = routeInfo => {
	return {
		type: actionTypes.CALL_API_POPULATE_SUCCESS,
		apiRouteInfo: routeInfo,
	};
};

export const callApiPopulate = memberInfo => {
	const route = memberInfo.watchComponentKey;
	const payload = {
		memberKey: route,
		members: memberInfo.allMembers,
		trackingNumber: memberInfo.trackingNumber,
	};

	const imsPacket = WrapImsPacket(payload);

	return dispatch => {
		dispatch(callApiPopulateStart());
		axiosInstance
			.post('/api/Applications/Population/' + route, imsPacket)
			.then(response => {
				switch (response.status) {
					case 200:
						if (response.data.responseCode) {
							const responseCode = response.data.responseCode;
							const data = response.data.payload;
							const messages = response.data.messages;
							const action = {
								...data,
								forceChildrenHidden:
									memberInfo.forceChildrenHidden,
							};
							switch (responseCode) {
								case 200:
									dispatch(
										callApiPopulateSuccess({
											action: action,
											formIndex:
												memberInfo.formToPopulateKey,
										}),
									);
									clearMessages();
									messages.forEach(message => {
										addMessage(message);
									});
									break;
								default:
									dispatch(callApiPopulateFail());
									clearMessages();
									messages.forEach(message => {
										addMessage(message);
									});
									break;
							}
						} else {
							dispatch(callApiPopulateFail());
						}
						break;
					default:
						dispatch(callApiPopulateFail());
						break;
				}
			})
			.catch(error => {
				dispatch(callApiPopulateFail());
			});
	};
};

export const callApiValidateSync = route => {
	return {
		type: actionTypes.CALL_API_VALIDATE,
		apiRouteInfo: route,
	};
};

export const callApiValidate = memberInfo => {
	const route =
		memberInfo.allMembers[memberInfo.memberToValidateKey].validation
			.validationRoute;

	//remove unnecessary members of `members` object
	const pairedDownMembers = deepCloneObject(memberInfo.allMembers);
	Object.keys(pairedDownMembers).forEach(mKey => {
		delete pairedDownMembers[mKey].elementConfig.cols;
		delete pairedDownMembers[mKey].elementConfig.rows;
		delete pairedDownMembers[mKey].elementConfig.placeholder;
		delete pairedDownMembers[mKey].elementConfig.styles;
		delete pairedDownMembers[mKey].esoIds;
		delete pairedDownMembers[mKey].extras;
		delete pairedDownMembers[mKey].isRole;
		delete pairedDownMembers[mKey].parent;
		delete pairedDownMembers[mKey].populationRoute;
		delete pairedDownMembers[mKey].showIfOptionSelected;
		delete pairedDownMembers[mKey].subelements;
		delete pairedDownMembers[mKey].sublabel;
	});

	const payload = {
		memberKey: memberInfo.memberToValidateKey,
		members: pairedDownMembers,
		map: memberInfo.componentMap,
		trackingNumber: memberInfo.trackingNumber,
	};

	const imsPacket = WrapImsPacket(payload);

	return dispatch => {
		axiosInstance
			.post('/api/Applications/Validation/' + route, imsPacket)
			.then(response => {
				dispatch(
					callApiValidateSync({
						data: response.data.payload,
						memberIndex: memberInfo.memberToValidateKey,
						formIndex: memberInfo.formToValidateKey,
					}),
				);
				dispatch(
					updateSubmitting({
						updatedValue: false,
					}),
				);
			})
			.catch(error => {});
	};
};

export const updateRequestType = requestType => {
	return {
		type: actionTypes.UPDATE_REQUEST_TYPE,
		requestType: requestType,
	};
};

export const revealValidation = payload => {
	return {
		type: actionTypes.REVEAL_VALIDATION,
		formId: payload.formId,
	};
};

export const updateMemberValue = payload => {
	return {
		type: actionTypes.UPDATE_MEMBER_VALUE,
		payload: payload,
	};
};

export const updateMemberValidity = payload => {
	return {
		type: actionTypes.UPDATE_MEMBER_VALIDITY,
		payload: payload,
	};
};

export const updateMemberVisibility = payload => {
	return {
		type: actionTypes.UPDATE_MEMBER_VISIBILITY,
		payload: payload,
	};
};

export const resetStore = () => {
	return {
		type: actionTypes.RESET_STORE,
	};
};
